<template>
    <div>
        <button
            class="open-button rounded-pill"
            v-on:click="openForm">
            <i class="far fa-envelope"></i>
            Chat
            <span
            v-if="mensajes_sin_leer1+mensajes_sin_leer2>0"
            style="position: absolute;top: -10px;right: -5px;padding: 5px 10px;border-radius: 50%;background: blue;color: white;"
            class="badge">
                {{mensajes_sin_leer1+mensajes_sin_leer2}}
            </span>
        </button>
        <div
            v-bind:style="{
                'background-color': cia.color_fondo_logo
            }"
            class="chat-popup" id="myForm">
            <button
                class="close mr-3 mt-3"
                v-on:click="closeForm(true)">
                <i class="fas fa-times"></i>
            </button>
            <div
                v-if="vista=='chats'"
                class="form-container">
                <h3>Chats</h3>
                <div
                    autocomplete="false"
                    v-on:submit.prevent="Nada"
                    class="mb-3 row">
                    <div
                        class="col-12"
                        id="div_buscar">
                        <input
                        v-model="buscar"
                        style="background-color:#e9ecef !important;"
                        placeholder="Buscar Empleado"
                        type="text"
                        class="form-control"
                        id="buscar" />
                    </div>
                </div>
                <div style="height:380px;max-height:380px;overflow-y:auto;overflow-x: hidden;">
                    <div
                        class="row mt-5"
                        v-if="chats.length==0 && chats2.length==0">
                        <div class="col-12 mt-5 text-center">
                            {{ $t("page.chat.no_hay_chat") }}
                        </div>
                    </div>
                    <div
                        v-else
                        class="row">
                        <div class="col-12">
                            <div
                                id="div_chats1"
                                v-on:click="ConsultarChat(chat,1)"
                                style="cursor:pointer;"
                                v-for="chat,index of chats"
                                :key="index+'chat'"
                                class="row border-bottom border-top mb-2 py-3">
                                <div class="col-3 px-3 pt-1 text-center">
                                    <img
                                    :src="chat.empleado2.foto"
                                    alt=""
                                    class="img-fluid rounded-circle border border-2">
                                </div>
                                <div class="col-8">
                                    <div class="row">
                                        <div class="col-12">
                                            <b>{{chat.empleado2.nombre}}</b>
                                        </div>
                                        <div
                                        style="font-size: 12px;"
                                        class="col-12 mt-2">
                                            <a
                                            v-if="chat.ultima_conexion=='en línea'"
                                            v-on:click.prevent="Nada"
                                            href=""
                                            class="btn-link text-success">
                                                <i class="fa fa-circle online"></i>
                                            </a>
                                            <a
                                            v-else
                                            v-on:click.prevent="Nada"
                                            href=""
                                            style="color:#6c757d9e !important;"
                                            class="btn-link">
                                                <i class="fa fa-circle online"></i>
                                            </a>
                                            {{chat.ultima_conexion}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-1 pt-2 text-left pl-0">
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                            <div
                                id="div_chats2"
                                v-on:click="ConsultarChat(chat2,2)"
                                style="cursor:pointer;"
                                v-for="chat2,index of chats2"
                                :key="index+'chat2'"
                                class="row border-bottom border-top mb-2 py-3">
                                <div class="col-3 px-3 pt-1 text-center">
                                    <img
                                    :src="chat2.empleado1.foto"
                                    alt=""
                                    class="img-fluid rounded-circle border border-2">
                                </div>
                                <div class="col-8">
                                    <div class="row">
                                        <div class="col-12">
                                            <b>{{chat2.empleado1.nombre}}</b>
                                        </div>
                                        <div class="col-12">
                                            <div
                                            style="font-size: 12px;"
                                            class="col-12 mt-2">
                                            <a
                                            v-if="chat2.ultima_conexion=='en línea'"
                                            v-on:click.prevent="Nada"
                                            href=""
                                            class="btn-link text-success">
                                                <i class="fa fa-circle online"></i>
                                            </a>
                                            <a
                                            v-else
                                            v-on:click.prevent="Nada"
                                            href=""
                                            style="color:#6c757d9e !important;"
                                            class="btn-link">
                                                <i class="fa fa-circle online"></i>
                                            </a>
                                            {{chat2.ultima_conexion}}
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-1 pt-2 text-left pl-0">
                                    <i class="fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-else-if="vista=='chat'"
                class="form-container">
                <div class="row border-bottom pb-2">
                    <div class="col-1 pl-0 pt-3 text-center">
                        <a
                        v-on:click.prevent="closeForm"
                        href=""
                        class="btn-link">
                            <i class="fas fa-chevron-left fa-lg"></i>
                        </a>
                    </div>
                    <div class="col-auto pl-0 text-left">
                        <img
                        v-if="tipo==1"
                        :src="chat.empleado2.foto"
                        alt=""
                        style="max-width:45px;height:auto;"
                        class="rounded-circle border border-2" />
                        <img
                        v-else
                        :src="chat.empleado1.foto"
                        alt=""
                        style="max-width:45px;height:auto;"
                        class="rounded-circle border border-2" />
                    </div>
                    <div class="col-7 pr-0 text-left pt-2">
                        <div class="row">
                            <div class="col-12 pr-0 text-left pl-0">
                                <b v-if="tipo==1" class="mt-1">
                                {{chat.empleado2.nombre}}
                                </b>
                                <b v-else class="mt-1">
                                {{chat.empleado1.nombre}}
                                </b>
                            </div>
                            <div
                                style="font-size:12px;"
                                class="col-12 px-0 text-left">
                                <a
                                v-if="chat.ultima_conexion=='en línea'"
                                v-on:click.prevent="Nada"
                                href=""
                                class="btn-link text-success">
                                    <i class="fa fa-circle online"></i>
                                </a>
                                <a
                                v-else
                                v-on:click.prevent="Nada"
                                href=""
                                style="color:#6c757d9e !important;"
                                class="btn-link">
                                    <i class="fa fa-circle online"></i>
                                </a>
                                {{chat.ultima_conexion}}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="cargando"
                    class="row my-5">
                    <div class="col-12 h-100">
                        <div class="d-flex justify-content-center">
                          <div class="spinner-border" role="status">
                            <span class="visually-hidden"></span>
                          </div>
                        </div>
                    </div>
                </div>
                <div
                    v-else
                    style="height:380px;max-height:380px;overflow-y:auto;"
                    id="div_mensajes"
                    class="row px-3 py-3 mb-1">
                    <div class="col-12">
                        <div
                        v-for="(mensaje,index) in mensajes" :key="index+'mensaje'"
                        class="row mb-1">
                            <div
                            v-if="mensaje.type=='img'"
                            :class="{
                                'ml-auto text-right':mensaje.empleado.clave==menu.usuario.cve_empleado
                            }"
                            style="max-width:85%;"
                            class="col-auto text-white rounded py-1 px-0">
                                <img
                                :src="mensaje.mensaje"
                                class="img-fluid"
                                 />
                            </div>
                            <div
                            v-else
                            :class="{
                                'ml-auto text-right bg-primary':mensaje.empleado.clave==menu.usuario.cve_empleado,
                                'bg-success':mensaje.empleado.clave!=menu.usuario.cve_empleado,
                            }"
                            style="max-width:85%;"
                            class="col-auto text-white rounded py-1">
                                {{mensaje.mensaje}}
                            </div>
                            <div
                            :class="{
                                'text-right':mensaje.empleado.clave==menu.usuario.cve_empleado
                            }"
                            class="col-12">
                                <small>
                                {{formatoFecha(mensaje.fecha,index)}}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 text-center" v-if="progress>0">
                        <div
                        class="d-flex w-100 align-items-center text-center">
                          <strong>{{ $t("page.chat.enviando") }}</strong>
                          <div class="spinner-border ml-3" role="status" aria-hidden="true"></div>
                        </div>
                    </div>
                </div>
                <form
                    autocomplete="false"
                    v-on:submit.prevent="Enviar(mensaje,'text')"
                    class="row pl-0">
                    <div class="col-1 mr-2 pl-0 text-left">
                        <button
                        v-on:click="Imagen"
                        type="button"
                        style="cursor:pointer;"
                        class="btn rounded-circle">
                            <i class="fas fa-lg fa-camera"></i>
                        </button>
                        <input
                        type="file"
                        accept="image/x-png,image/jpeg"
                        v-on:change="CargarImagen"
                        class="d-none"
                        id="enviarimagen" />
                    </div>
                    <div class="col-9 pr-0">
                        <input
                        v-model="mensaje"
                        style="background-color:#e9ecef !important;"
                        placeholder="Escribe tu mensaje"
                        type="search"
                        maxlength="100"
                        autocomplete="off"
                        class="form-control"
                        name="new-password"
                        id="new-password" />
                    </div>
                    <div class="col-1 px-0 text-center">
                        <button
                        type="submit"
                        class="btn rounded-circle">
                            <i class="fas mx-auto fa-lg fa-paper-plane"></i>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue';
import { mapActions } from 'vuex';
import {firestore,Timestamp,storage,database} from '@/firebase.js';
import firebase from 'firebase/app';
export default {
    data () {
        return {
            mensajes_sin_leer1:0,
            mensajes_sin_leer2:0,
            tipo:1,
            progress:0,
            chat:{
                id:null,
                empleado1:{
                    clave:null,
                    nombre:'',
                    estatus:1
                },
                empleado2:{
                    clave:null,
                    nombre:'',
                    estatus:1
                }
            },
            vista:'chats',
            mensaje:'',
            buscar:'',
            chats:[],
            chats2:[],
            mensajes:[],
            cargando:true
        }
    },
    methods:{
        Imagen(){
            $('#enviarimagen').click();
        },
        EnviarImagen(file){
            var that = this;
            var storageRef = storage.ref();
            var extension = this.extension(file.name);
            var firebase_firestore = this.cia.firebase_firestore;
            that.progress=1;
            var nombrearchivo = Date.now();

            $(document).ready(function(){
                var d = $('#div_mensajes');
                d.scrollTop(d.prop("scrollHeight"));
            });
            var uploadTask = storageRef.child('empresas/' +firebase_firestore+'/chats/'+nombrearchivo+'.'+extension).put(file);
            uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
                function(snapshot) {
                    that.progress = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100)+1;
                }, function(error) {
                    console.log('Error al subir imagen uploadTask',error);
                    swal('Problemas para subir la imagen','','error');
                    that.progress=0;
                }, function() {
                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                        that.Enviar(downloadURL,'img');
                    });
                }
            );
        },
        CargarImagen(){
            var that = this;
            var file = document.querySelector('#enviarimagen').files[0];
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                that.EnviarImagen(file);
            };
            reader.onerror = function (error) {
                swal('Problemas para cargar la imagen','','error');
            };
        },
        extension(filename) {
          var r = /.+\.(.+)$/.exec(filename);
          return r ? r[1] : null;
        },
        Enviar(mensaje,type){
            var that = this;
            if (this.mensaje.length==0 && type=='text') {
                return;
            }
            var to_cve_empleado = that.menu.usuario.cve_empleado;
            if (to_cve_empleado==that.chat.empleado1.clave) {
                to_cve_empleado=that.chat.empleado2.clave;
            }else{
                to_cve_empleado=that.chat.empleado1.clave;
            }
            var mensaje_enviar=mensaje;
            if (type=='img') {
                mensaje_enviar='Envió una imagen';
            }
            firestore.collection('empresas')
            .doc(this.cia.firebase_firestore)
            .collection('chats')
            .doc(that.chat.id)
            .collection('mensajes')
            .add({
                empleado:{
                    clave:that.menu.usuario.cve_empleado
                },
                type:type,
                mensaje:mensaje,
                fecha:firebase.firestore.FieldValue.serverTimestamp(),
                estatus:1
            }).then(response=>{
                firestore.collection('empresas')
            .doc(this.cia.firebase_firestore).collection('chats')
                .doc(that.chat.id).update({
                    ultimo_mensaje:{
                        empleado:{
                            clave:that.menu.usuario.cve_empleado
                        },
                        mensaje:mensaje,
                        fecha:firebase.firestore.FieldValue.serverTimestamp(),
                        estatus:1
                    }
                });
                this.$http.post('chat/mensajes',{
                    mensaje:mensaje_enviar,
                    cve_empleado:to_cve_empleado,
                })
                .then(respuesta=>{return respuesta.json()})
                .then(respuestaJson=>{

                })
                .catch(error=>{
                    console.log('Error al enviar las notificaciones',error);
                });
                that.progress=0;
                $(document).ready(function(){
                    var d = $('#div_mensajes');
                    d.scrollTop(d.prop("scrollHeight"));
                });
            });
            this.mensaje="";
        },
        formatoFecha(fecha,index){
            let mismo=false;
            if (this.mensajes[index+1]!=undefined) {
                if (this.mensajes[index].empleado.clave==this.mensajes[index+1].empleado.clave) {
                    mismo=true;
                }
            }
            if (mismo) {
                return "";
            }else if(fecha==null){
                return "";
            }else{
                return moment(fecha.toDate()).fromNow();
            }
        },
        ConsultarChat(chat,tipo){
            this.tipo=tipo;
            var that = this;
            this.vista='chat';
            this.chat = chat;
        },
        BuscarChat(empleado){
            var that = this;
            this.vista='chat';
            let foto_empleado = empleado.foto_empleado;
            if (empleado.foto_empleado==null || empleado.foto_empleado=="") {
                foto_empleado = 'https://labsoftmonterrey.site/v3/static/img/empleados/foto_base.png';
            }
            firestore.collection('empresas')
            .doc(this.cia.firebase_firestore).collection('chats')
            .where('empleado1.clave','==',that.menu.usuario.cve_empleado)
            .where('empleado2.clave','==',empleado.cve_empleado)
            .orderBy('ultimo_mensaje.fecha','desc')
            .limit(1).get().then(querySnapshot=>{
                let dato = null;
                querySnapshot.forEach(doc=>{
                    dato=doc.data();
                    dato.id=doc.id;
                });
                if (dato==null) {
                    firestore.collection('empresas')
            .doc(this.cia.firebase_firestore).collection('chats')
                    .where('empleado1.clave','==',empleado.cve_empleado)
                    .where('empleado2.clave','==',that.menu.usuario.cve_empleado)
                    .orderBy('ultimo_mensaje.fecha','desc')
                    .limit(1).get().then(querySnapshot=>{
                        let dato2 = null;
                        querySnapshot.forEach(doc=>{
                            dato2=doc.data();
                            dato2.id=doc.id;
                        });
                        if (dato2==null) {
                            firestore.collection('empresas')
            .doc(this.cia.firebase_firestore)
                            .collection('chats')
                            .add({
                                empleado1:{
                                    clave:that.menu.usuario.cve_empleado,
                                    nombre:that.menu.usuario.nombre_empleado,
                                    foto:that.menu.usuario.foto_empleado
                                },
                                empleado2:{
                                    clave:empleado.cve_empleado,
                                    nombre:empleado.nombre_empleado,
                                    foto:foto_empleado
                                },
                                ultimo_mensaje:{
                                    empleado:{
                                        clave:that.menu.usuario.cve_empleado
                                    },
                                    mensaje:'Nuevo chat',
                                    fecha:firebase.firestore.FieldValue.serverTimestamp(),
                                    estatus:1
                                },
                                ultima_conexion:''
                            }).then(docRef=>{
                               firestore.collection('empresas')
            .doc(this.cia.firebase_firestore)
                               .collection('chats')
                               .doc(docRef.id)
                               .get().then(doc=>{
                                let dato = doc.data();
                                dato.id=doc.id;
                                that.chat=dato;
                               })
                            })
                        }else{
                            that.chat=dato2;
                        }
                    })
                }else{
                    that.chat=dato;
                }
            });
        },
        Nada(){

        },
        openForm() {
          document.getElementById("myForm").style.display = "block";
        },
        closeForm(cerrar) {
            if (this.vista=='chat') {
                this.vista='chats';
                this.chat={
                    id:null,
                    empleado1:{
                        clave:null,
                        nombre:'',
                        estatus:1
                    },
                    empleado2:{
                        clave:null,
                        nombre:'',
                        estatus:1
                    }
                };
                this.$unbind('mensajes');
                this.mensajes=[];
            }else{
                this.vista='chats';

            }
            if (cerrar==true) {
                document.getElementById("myForm").style.display = "none";
            }
        },
        DefinirConexion(){
            var that = this;
            var clave = this.menu.usuario.cve_empleado;
            var nombre = this.menu.usuario.nombre_empleado;
            var firebase_firestore = this.cia.firebase_firestore;
            var userStatusDatabaseRef = database.ref('/empresas/'+firebase_firestore+'/status/' + clave);
            var isOfflineForDatabase = {
                state: 'offline',
                clave:clave,
                nombre:nombre,
                last_changed: firebase.database.ServerValue.TIMESTAMP,
            };
            var isOnlineForDatabase = {
                state: 'online',
                clave:clave,
                nombre:nombre,
                last_changed: firebase.database.ServerValue.TIMESTAMP,
            };
            var userStatusFirestoreRef = firestore.collection('empresas')
                .doc(firebase_firestore).collection('status').doc(clave);
            var isOfflineForFirestore = {
                state: 'offline',
                clave:clave,
                nombre:nombre,
                last_changed: firebase.firestore.FieldValue.serverTimestamp(),
            };
            var isOnlineForFirestore = {
                state: 'online',
                clave:clave,
                nombre:nombre,
                last_changed: firebase.firestore.FieldValue.serverTimestamp(),
            };
            database.ref('empresas/'+firebase_firestore+'/connected').on('value', function(snapshot) {
                if (snapshot.val() == false) {
                    userStatusFirestoreRef.set(isOfflineForFirestore);
                    return;
                };
                userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(function() {
                    userStatusDatabaseRef.set(isOnlineForDatabase);
                    userStatusFirestoreRef.set(isOnlineForFirestore);
                });
            });
        },
        ConsultarEstatusChats(){
            var that = this;
            var cve_empleado=this.menu.usuario.cve_empleado;
            var firebase_firestore = this.cia.firebase_firestore;
            this.chats.forEach((chat,index)=>{
                firestore.collection('empresas')
                .doc(firebase_firestore)
                .collection('status')
                .doc(chat.empleado2.clave)
                .get().then(doc=>{
                    if (doc.exists) {
                        if (doc.data().state=='online') {
                            that.chats[index].ultima_conexion='en línea';
                        }else{
                            that.chats[index].ultima_conexion='últ. vez '+moment(doc.data().last_changed.toDate()).fromNow();
                        }
                    }else{
                        that.chats[index].ultima_conexion="Aún no se a conectado";
                    }
                });
            });
        },
        ConsultarEstatusChats2(){
            var that = this;
            var cve_empleado=this.menu.usuario.cve_empleado;
            var firebase_firestore = this.cia.firebase_firestore;
            this.chats2.forEach((chat,index)=>{
                firestore.collection('empresas')
                .doc(firebase_firestore)
                .collection('status')
                .doc(chat.empleado1.clave)
                .get().then(doc=>{
                    if (doc.exists) {
                        if (doc.data().state=='online') {
                            that.chats2[index].ultima_conexion='en línea';
                        }else{
                            that.chats2[index].ultima_conexion='últ. vez '+moment(doc.data().last_changed.toDate()).fromNow();
                        }
                    }else{
                        that.chats2[index].ultima_conexion="Aún no se a conectado";
                    }
                });
            });
        },
        ...mapActions(['Actualizar_Notificaciones'])
    },
    computed:{
        menu(){
          return this.$store.getters.getMenu;
        },
        cia(){
          return this.$store.getters.getCia;
        },
    },
    watch:{
        chats:function(){
            this.ConsultarEstatusChats();
            this.mensajes_sin_leer1=0;
            if ( !$("#myForm").is(':visible') ){
                this.Actualizar_Notificaciones();
                for (var i = 0; i < this.chats.length; i++) {
                    if (this.chats[i].ultimo_mensaje.estatus==1) {
                        this.mensajes_sin_leer1++;
                    }
                }
            }
        },
        chats2:function(){
            this.ConsultarEstatusChats2();
            this.mensajes_sin_leer2=0;
            if ( !$("#myForm").is(':visible') ){
                this.Actualizar_Notificaciones();
                for (var i = 0; i < this.chats2.length; i++) {
                    if (this.chats2[i].ultimo_mensaje.estatus==1) {
                        this.mensajes_sin_leer2++;
                    }
                }
            }
        },
        mensajes:function(){
            $(document).ready(function(){
                setTimeout(function(){
                    var d = $('#div_mensajes');
                    d.scrollTop(d.prop("scrollHeight"));
                },1000);
            });
        },
        vista:function(){
            var that = this;
            if (this.vista=='chats') {
                $(document).ready(function(){
                    $('#buscar').autocomplete({
                        appendTo: "#div_buscar",
                        source: that.$http.options.url+'/plan_capacitacion/simulador_puesto/autocomplete/empleados'+that.buscar,
                        minLength: 4,
                        select: function(event,ui){
                          that.BuscarChat(ui.item);
                          that.buscar="";
                        }
                    });
                })
            }
            this.ConsultarEstatusChats();
            this.ConsultarEstatusChats2();
        },
        'chat.id':function(){
            var that = this;
            if (this.chat.id!=null) {
                this.cargando=true;
                that.$bind(
                    'mensajes',
                    firestore.collection('empresas')
            .doc(this.cia.firebase_firestore).collection('chats')
                    .doc(that.chat.id)
                    .collection('mensajes')
                    .orderBy('fecha','asc')
                    .limit(50)
                ).then(mensajes => {
                  that.cargando=false;
                  if (that.chat.ultimo_mensaje.empleado.clave!=that.menu.usuario.cve_empleado && that.chat.ultimo_mensaje.estatus==1) {
                    var ultimo_mensaje=that.chat.ultimo_mensaje;
                    ultimo_mensaje.estatus=2;
                    firestore.collection('empresas')
            .doc(this.cia.firebase_firestore).collection('chats')
                    .doc(that.chat.id).update({
                        ultimo_mensaje:ultimo_mensaje
                    });
                  }
                  $(document).ready(function(){
                    var d = $('#div_mensajes');
                    d.scrollTop(d.prop("scrollHeight"));
                  });
                });
            }
        }
    },
    created(){
        var that = this;
        this.$bind(
            'chats',
            firestore.collection('empresas')
            .doc(this.cia.firebase_firestore).collection('chats')
            .where('empleado1.clave','==',that.menu.usuario.cve_empleado)
            .orderBy('ultimo_mensaje.fecha','desc')
            .limit(5)
        );
        this.$bind(
            'chats2',
            firestore.collection('empresas')
            .doc(this.cia.firebase_firestore).collection('chats')
            .where('empleado2.clave','==',that.menu.usuario.cve_empleado)
            .orderBy('ultimo_mensaje.fecha','desc')
            .limit(5)
        );
    },
    mounted(){
        var that = this;
        $('#buscar').autocomplete({
            appendTo: "#div_buscar",
            source: that.$http.options.url+'/plan_capacitacion/simulador_puesto/autocomplete/empleados'+that.buscar,
            minLength: 4,
            select: function(event,ui){
              that.BuscarChat(ui.item);
              that.buscar="";
            }
        });
        this.DefinirConexion();
    }
};
</script>

<style scoped>


.open-button {
  background-color: #ea1e1e;
  color: white;
  padding: 16px 20px;
  border: none;
  cursor: pointer;
  /*opacity: 0.8;*/
  position: fixed;
  bottom: 15px;
  right: 28px;
  width: 100px;
}

/* The popup chat - hidden by default */
.chat-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 1px;
  border: 3px solid #f1f1f1;
  z-index: 9999;
}

/* Add styles to the form container */
.form-container {
  max-width: 320px;
  width: 320px;
  margin: 3px;
  background-color: white;
  padding: 15px;
}

/* Full-width textarea */
.form-container textarea {
  width: 100%;
  padding: 15px;
  margin: 5px 0 22px 0;
  border: none;
  background: #f1f1f1;
  resize: none;
  min-height: 200px;
}

/* When the textarea gets focus, do something */
.form-container textarea:focus {
  background-color: #ddd;
  outline: none;
}



/* Add a red background color to the cancel button */
.form-container .cancel {
  background-color: red;
}

/* Add some hover effects to buttons */
.form-container .btn:hover, .open-button:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Chat/Chat.vue